import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconLessThanOrEqualToSymbolGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M427.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C72 167.1 64 178.9 64 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L182.2 192 427.9 93.7zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 416z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconLessThanOrEqualToSymbolSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      viewBox="0 0 512 512"
      {...(props.svg ?? {})}
    >
      <IconLessThanOrEqualToSymbolGroup {...props} />
    </svg>
  );
};
